module.exports = __webpack_public_path__ + "img/youtube-source.13548fe0.svg";